import * as angular from "angular";
import {IController} from "angular";

export class FulfillmentMapPanelComponent implements IController {

  fulfillmentSteps: any;
  serviceAreaIds: string[];

  public serviceAreasRef: any;
  public serviceAreas: any;


  constructor(private $serviceArea) {
    this.serviceAreasRef = this.$serviceArea();
  }

  $onInit() {
    this.getServiceAreas();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.serviceAreaIds && !changes.serviceAreaIds.isFirstChange()) {
      this.getServiceAreas();
    }
  }

  private getServiceAreas() {
    this.serviceAreas = [];
    if (!this.serviceAreaIds?.length) {
      return;
    }
    this.serviceAreasRef.$asyncValues(this.serviceAreaIds)
      .then((serviceAreas) => {
        this.serviceAreas = serviceAreas;
      })
  }
}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentMapPanel', {
    bindings: {
      fulfillmentSteps: '<',
      serviceAreaIds: '<?'
    },
    template: require('./fulfillment-map-panel.html').default,
    controller: FulfillmentMapPanelComponent
  });
